import React from 'react'
import TerritoryCard from './TerritoryCard'
import './TerritoryGrid.css'

const TerritoryGrid = ({ territories }) => (
  <div className="territory-grid">
    {territories.map((territory, index) => (
      <TerritoryCard key={territory.slug || territory.territoryId || index} territory={territory} />
    ))}
  </div>
)

export default TerritoryGrid
